import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Stack,
} from '@chakra-ui/react';
import { BusinessModel } from 'interfaces/BusinessModel.interface';
import IntakeConfig from 'interfaces/IntakeConfig.interface';
import React, {
  useMemo,
} from 'react';
import { Form } from 'react-final-form';
import setFieldTouched from '../../../components/form/setFieldTouched';
import usePage from '../../../hooks/usePage';
import { INTAKE_VIEWED } from '../../../services/analytics/events';
import { useTrack } from '../../../services/analytics/hooks';
import normalizeFormState from '../normalizeFormState';
import {
  FormState,
  initialState,
} from '../state';
import BusinessDetailsSection from './BusinessDetailsSection';
import BusinessMainSection from './BusinessMainSection';
import BusinessPlanSection from './BusinessPlanSection';

const BusinessView = ({
  onComplete,
  config,
}: {
  onComplete: (business: BusinessModel) => void,
  config: IntakeConfig
}) => {
  useTrack(INTAKE_VIEWED);

  const views = (config.plans && config.plans.length === 1)
    ? ['business', 'details']
    : ['business', 'plan', 'details'];
  const lastPage = views.length - 1;
  const [page, next, decrement] = usePage(0, lastPage);

  const initialValues = useMemo(
    () => {
      return {
        ...initialState.form,
        partner: config.partner,
        plan: config.plans?.[0].value,
        id: config.partner.code,
        token: '',
        address: {
          ...initialState.form.address,
          country: config.countries[0],
        },
        questions: config.questions,
      };
    },
    [],
  );

  // eslint-disable-next-line consistent-return
  const onSubmit = (form: FormState) => {
    if (page < lastPage) {
      return next();
    }

    console.log('submit form', form);
    const normalizedState = normalizeFormState(form, config);
    console.log('normalizedState', normalizedState);
    onComplete(normalizedState);
  };

  // @ts-ignore
  return (
    <Box>
      <Form onSubmit={onSubmit} initialValues={initialValues} mutators={{ setFieldTouched }}>
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <Stack direction="column" spacing={8} w="100%">
              {props.submitFailed && props.hasValidationErrors && (
                <Alert status="error">
                  <AlertIcon />
                  <AlertDescription>Please check the form for errors and try again.</AlertDescription>
                </Alert>
              )}
              {views[page] === 'business' && (
                // @ts-ignore
                <BusinessMainSection config={config} />
              )}
              {views[page] === 'plan' && (
                <BusinessPlanSection config={config} onBack={decrement} />
              )}
              {views[page] === 'details' && (
                <BusinessDetailsSection
                  config={config}
                  onBack={decrement}
                />
              )}
            </Stack>
            {/*<pre>*/}
            {/*  {JSON.stringify(props.values, null, 2)}*/}
            {/*</pre>*/}
          </form>
        )}
      </Form>
    </Box>
  );
};

export default BusinessView;
